import { useLoaderData } from 'react-router'
import { CallToAction } from '~/utils/a-b'
import { fetchChangelog } from './changelog.server'
import { ChangelogTicker } from './changelog-ticker'
import { HeroCard } from './hero-card'
import { Wall } from './wall'
import { WhatPeopleBuild } from './builds'
import { Demos } from './demos'
import { Setup } from './setup'
import { QUOTES } from './data/quotes'
import { QuoteCarousel } from '~/components/quote-section/quote-carousel'
import { fetchDocsDemos } from '~/services/docs-demos'
import styles from './style.css?url'
import heroStyles from '~/components-v2/hero/hero.css?url'
import tabAccordionStyles from '~/components-v2/tab-accordion/tab-accordion.css?url'
import quoteStyles from '~/components/quote-section/quote-section.css?url'
import carouselRailStyles from '~/components-v2/carousel-rail/carousel-rail.css?url'
import carouselButtonStyles from '~/components-v2/carousel-button-next/carousel-button-next.css?url'
import linkCtaNextStyles from '~/components-v2/link-cta-next/link-cta-next.css?url'
import engineeringDemoStyles from '~/components-v2/engineering-demo/engineering-demo.css?url'
import figureStyles from '~/components-v2/figure/figure.css?url'

export { meta } from '~/utils'

export const loader = async () => ({
  title: 'Build analytics like software',
  description:
    'Bring your own tools and workflows. Build, test, manage, and deploy on one governed platform.',
  changelog: await fetchChangelog(),
  docsDemos: await fetchDocsDemos().catch(() => undefined),
})

export const links = () => [
  { rel: 'stylesheet', href: heroStyles },
  { rel: 'stylesheet', href: tabAccordionStyles },
  { rel: 'stylesheet', href: quoteStyles },
  { rel: 'stylesheet', href: carouselRailStyles },
  { rel: 'stylesheet', href: carouselButtonStyles },
  { rel: 'stylesheet', href: linkCtaNextStyles },
  { rel: 'stylesheet', href: engineeringDemoStyles },
  { rel: 'stylesheet', href: figureStyles },
  { rel: 'stylesheet', href: styles },
]

function DevelopersPage() {
  const { title, description, changelog, docsDemos } =
    useLoaderData<typeof loader>()

  return (
    <>
      <header className="page-section page-section--lg hero developers-hero">
        <div className="page-section__inner developers-hero__inner">
          <hgroup className="developers-hero__text">
            <h1 className="heading-xl text-brand-dark">{title}</h1>
            <p className="body-l text-primary">{description}</p>
            <CallToAction />
          </hgroup>
          <HeroCard />
        </div>
      </header>

      <Wall />

      <Setup />

      <WhatPeopleBuild />

      <div className="developers-quotes" id="quotes">
        <QuoteCarousel heading="What developers say" quotes={QUOTES} />
      </div>

      <Demos docsDemos={docsDemos} />

      <ChangelogTicker items={changelog} />
    </>
  )
}

export default DevelopersPage
